import { jsx as n, jsxs as a } from "react/jsx-runtime";
import b from "markdown-to-jsx";
import c from "@mui/material/Box";
import C from "@mui/material/Container";
import H from "@mui/material/Divider";
import y from "@mui/material/Grid";
import e from "@mui/material/Typography";
import { makeStyles as L } from "tss-react/mui";
import { CardBase as _ } from "../../../../common/Cards/CardBase/CardBase.js";
import v from "../../../../common/Image/Image.js";
import { CUSTOMER_DEFAULT_RATING as j } from "../../constant/index.js";
import k from "./Testimonial.style.js";
const B = L()(k), D = ({ data: s }) => {
  var h;
  const { classes: o } = B(), T = (s == null ? void 0 : s.heading) ?? "", t = (s == null ? void 0 : s.subHeading) ?? "", i = (s == null ? void 0 : s.list) ?? [], S = ((h = i == null ? void 0 : i[0]) == null ? void 0 : h.rating) ?? j, w = Array.from({ length: S }, (r, m) => m + 1);
  return /* @__PURE__ */ n(c, { py: { xs: 6, sm: 10, md: 15 }, className: o.wrapper, children: /* @__PURE__ */ a(C, { children: [
    /* @__PURE__ */ n(y, { container: !0, columnSpacing: 3, rowSpacing: 4, children: /* @__PURE__ */ a(y, { item: !0, xs: 12, sx: { textAlign: "center" }, mb: { xs: 3 }, children: [
      /* @__PURE__ */ n(e, { variant: "h1", mb: { xs: 1 }, className: o.heading, children: T }),
      /* @__PURE__ */ n(
        e,
        {
          variant: "h4",
          mb: { xs: 0, md: 2 },
          className: o.subHeading,
          children: t
        }
      )
    ] }) }),
    i && i.map((r) => {
      var f, N;
      const m = (r == null ? void 0 : r.id) ?? 0, d = (r == null ? void 0 : r.title) ?? "", g = (r == null ? void 0 : r.description) ?? "", p = (r == null ? void 0 : r.name) ?? "", l = (r == null ? void 0 : r.designation) ?? "", x = ((f = r == null ? void 0 : r.customerImg) == null ? void 0 : f.url) ?? "", u = ((N = r == null ? void 0 : r.companyLogo) == null ? void 0 : N.url) ?? "";
      return /* @__PURE__ */ n(_, { className: o.card, children: /* @__PURE__ */ a(c, { p: { xs: 1, sm: 2 }, children: [
        /* @__PURE__ */ a(c, { mb: { xs: 2, sm: 3 }, className: o.cardHeader, children: [
          /* @__PURE__ */ n(
            v,
            {
              src: "/images/png/quotes-icon.png",
              width: 40,
              height: 40
            }
          ),
          /* @__PURE__ */ n(c, { children: w.map((A) => /* @__PURE__ */ n(c, { component: "span", mx: { xs: 0.4 }, children: /* @__PURE__ */ n(
            v,
            {
              src: "/images/png/star-icon.png",
              width: 24,
              height: 24
            }
          ) }, A)) })
        ] }),
        /* @__PURE__ */ a(c, { mb: { xs: 2, sm: 3 }, children: [
          d && /* @__PURE__ */ n(
            e,
            {
              variant: "h2",
              mb: { xs: 2, sm: 3 },
              className: o.title,
              children: /* @__PURE__ */ n(b, { children: d })
            }
          ),
          g && /* @__PURE__ */ n(
            e,
            {
              variant: "body",
              className: o.description,
              children: /* @__PURE__ */ n(b, { children: g })
            }
          )
        ] }),
        /* @__PURE__ */ n(H, {}),
        /* @__PURE__ */ a(c, { mt: { xs: 2, sm: 3 }, className: o.cardFooter, children: [
          /* @__PURE__ */ a(
            c,
            {
              mb: { xs: 3, sm: 0 },
              className: o.authorProfile,
              children: [
                x && /* @__PURE__ */ n(
                  c,
                  {
                    mr: { xs: 0, sm: 1.5 },
                    mb: { xs: 1, sm: 0 },
                    className: o.customerImg,
                    children: /* @__PURE__ */ n("img", { src: x, alt: "Customer Profile Img" })
                  }
                ),
                /* @__PURE__ */ a(c, { children: [
                  p && /* @__PURE__ */ n(e, { variant: "h6", className: o.author, children: p }),
                  l && /* @__PURE__ */ n(
                    e,
                    {
                      variant: "smallText",
                      className: o.designation,
                      children: l
                    }
                  )
                ] })
              ]
            }
          ),
          u && /* @__PURE__ */ n(c, { className: o.companyImg, children: /* @__PURE__ */ n("img", { src: u, alt: "Company Logo" }) })
        ] })
      ] }) }, m);
    })
  ] }) });
}, K = D;
export {
  K as default
};
